import { ProductMapper } from "@omni/mappers/product/product.mapper";
import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";

import { ProductBundleMapper } from "@/api/mappers/productBundles.mapper";
import { BreakpointProvider } from "@/utils/breakpoints/breakpoints.provider";

import { ProductBundlesComponent } from "./productBundles.component";
import "./productBundles.scss";

export type ProductBundleProps = {
    product: Product<ProductFieldSet.Full>;
    className?: string;
};

export const ProductBundles = ({ product, className }: ProductBundleProps) => {
    if (product.productBundles.length === 0) return null;

    const mainProduct = ProductMapper.fromFullToProductTile(product);
    const productBundles = product.productBundles.map(ProductBundleMapper);

    return (
        <BreakpointProvider>
            <ProductBundlesComponent
                mainProduct={mainProduct}
                productBundles={productBundles}
                className={className}
            />
        </BreakpointProvider>
    );
};
